<template>
  <div class="slide-show-component-wraper" :class="{ 'modal-ui-active': modalActive }">
    <ul class="pgwSlideshow gallery-class">
      <li v-for="(element, index) in elements" :key="'elem_' + index">
        <img
          class="image-scale"
          :src="getImageSrc(element)"
          :alt="element.alt"
          :data-description="element.dataDescription"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import $ from 'jquery';
import pgwSlideshow from '@/assets/js/pgwslideshow';
export default {
  name: 'tr-gallery',
  props: [],
  beforeDestroy: function() {
    console.log('Gallery deactivate');
    this.$store.commit('GALLERY_DEACTIVATE');
    // this.$store.getters.galleryEngin.audio.pause();
    this.$store.getters.galleryEngin.destroy();
  },
  mounted: function() {
    console.log('GALLERY MOUNT');
    var that = this;
    var pgwSlideshow;
    let height = $('.image-scale').height();
    console.log('height', height);
    var audio = {};
    // test opoznienia dla galerii
    new Promise(function(resolve, reject) {
      setTimeout(function() {
        pgwSlideshow = $('.pgwSlideshow').pgwSlideshow({
          // maxHeight: that.elements.length > 1 ? height : height + 112,
          maxHeight: that.elements.length > 1 ? height : height + 112,
          displayList: that.elements.length > 1 ? true : false,
          // afterSlide: function ( id ) {
          //   if(that.elements.backgroundAudio) {
          //     audio = document.createElement( 'audio' );
          //     audio.src = 'static/audio/test/test.mp3';
          //     console.log( 'START audio', audio );
          //     audio.play();
          //   }
          // }
        });
        $('.pgwSlideshow')
          .find('.ps-current ul')
          .click(function() {
            // console.log( 'DOUBLE' );
            let $elem = $('.pgwSlideshow').find('.ps-current  li:visible img');
            let src = $elem.attr('src');
            let width = $elem.prop('naturalWidth');
            let height = $elem.prop('naturalHeight');
            // console.log( $elem );
            that.$store.commit('IMAGE_ZOOM_ACTIVATE');
            that.$store.commit('CHANGE_IMAGE_ZOOM_CONTENT', {
              src,
              width,
              height,
            });
          });
        resolve({
          destroy: pgwSlideshow.destroy,
          nextSlide: pgwSlideshow.nextSlide,
          previousSlide: pgwSlideshow.previousSlide,
          getCurrentSlide: pgwSlideshow.getCurrentSlide,
          getSlideCount: pgwSlideshow.getSlideCount,
          // audio
        });
      }, 400);
    }).then(function(result) {
      that.$store.dispatch('setGalleryEngin', result);
      // console.log( 'STOP audio', audio );
      // new Promise( function ( resolve, reject ) {
      //   setTimeout( function ( audio ) {
      //     console.log( 'in STOP audio', audio );
      //     console.log( "STOP" );
      //     resolve( audio );
      //   }, 1000 );
      // } ).then( function ( result ) {
      //   audio.pause();
      // } );
    });
  },
  methods: {
    getImageSrc(data) {
      let imageSrc = data.imageSrc;
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
  },
  computed: {
    elements() {
      return this.$store.getters.galleryData.items;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
    imageZoomActive() {
      return this.$store.getters.imageZoomActive;
    },
    isModalImageActive() {
      return this.$store.getters.isModalImageActive;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/css/pgwslideshow.css';
@import '~@/assets/sass/variable';
.gallery {
  .image-scale {
    height: 920px;
  }
  .modal-ui-active {
    pointer-events: auto;
  }
  .ps-selected {
    box-shadow: -1px 9px 18px 0 rgba(0, 0, 0, 0.75);
  }
  /**
     * znikanie podpisu dla galerii
     */
  .pgwSlideshow {
    background: #fff;

    .ps-list {
      border-top: 1px solid #fff !important;
      box-shadow: 0 10px 10px -5px #6f6f6f inset !important;
      background: #ffffff !important;
    }
  }
  .ps-current {
    // isolation: isolate;
    ul {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      height: 100% !important;
      padding-right: 40px !important;
    }
    .ps-caption {
      font-size: 1.4rem;
      z-index: 3;
      color: $borderColor;
      background: rgba(0, 0, 0, 0.64);
      // mix-blend-mode: normal;
      // opacity: 0;
      transition: opacity 0.6s ease;
    }
  }
}
</style>
